export const resetAlerts = () => (dispatch) => {
  dispatch({ type: "RESET_ALERTS" });
};
export const resetUpToDateFlag = () => (dispatch) => {
  dispatch({ type: "RESET_UPTODATE_FLAG" });
};
